/* eslint-disable max-len */
import { TextInput } from '@mantine/core';
import { useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { useTeamMemberContext } from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/TeamMemberDetailsContext';

const TeamMemberAddressInput = () => {
    const intl = useIntl();
    const { values } = useTeamMemberContext();
    const { address } = values;

    return (
        <TextInput
            id="address-input-in-team-member"
            label={intl.formatMessage(sharedMessages.address)}
            value={address}
            disabled
        />
    );
};

export default TeamMemberAddressInput;
